export default __webpack_public_path__ + "static/media/cny_2024-cn.8ecd1fc7.webp";